/**
 * User-related utility functions
 */

/**
 * Extract user_profile_id from various user object structures
 * This utility handles different response formats from user APIs
 *
 * Priority order:
 * 1. user_profile_id (direct or nested in data)
 * 2. Profile.user_profile_id (for User objects with Profile)
 * 3. uuid (fallback for some user objects)
 * 4. Username (Cognito username, last resort)
 * 5. user_id (alternative ID field)
 */
export const getUserProfileId = (user: any): string => {
  if (!user) {
    return '';
  }

  return (
    user.user_profile_id ||
    user.data?.user_profile_id ||
    user.Profile?.user_profile_id ||
    user.uuid ||
    user.Username ||
    user.data?.Username ||
    user.user_id ||
    user.data?.user_id ||
    ''
  );
};

/**
 * Extract Cognito Username from various user object structures
 * Use this when you specifically need the Cognito username
 */
export const getCognitoUsername = (user: any): string => {
  if (!user) {
    return '';
  }

  return (
    user.Username ||
    user.data?.Username ||
    user.user_id ||
    user.data?.user_id ||
    ''
  );
};

/**
 * Check if a user object has a valid user_profile_id
 */
export const hasUserProfile = (user: any): boolean => {
  return !!(
    user?.user_profile_id ||
    user?.data?.user_profile_id ||
    user?.Profile?.user_profile_id
  );
};
